// extracted by mini-css-extract-plugin
export default {"userpic":"styles_userpic__VWh-O","letter":"styles_letter__c9IOE","image":"styles_image__KK5OO"};